export default __webpack_public_path__ + "static/medialinq-button-2-4e13f8649c6b42212111b98391bc7853.png";